/**
 * Security Utilities
 * Staffing Command Center
 * Built and maintained by Angel Carreon (acarreom)
 * Copyright © 2025. All rights reserved.
 */

// Simple hex decode function for obfuscated credentials
const hexDecode = (hex) => {
  try {
    if (!hex || hex.length % 2 !== 0) {
      return '';
    }
    
    let result = '';
    for (let i = 0; i < hex.length; i += 2) {
      const hexPair = hex.substr(i, 2);
      const charCode = parseInt(hexPair, 16);
      result += String.fromCharCode(charCode);
    }
    return result;
  } catch (error) {
    return '';
  }
};

// Get admin credentials (still client-side, but obfuscated)
export const getAdminCredentials = () => {
  const emailHash = process.env.REACT_APP_ADMIN_EMAIL_HASH || "6163617272656f6d40616d617a6f6e2e636f6d";
  const passwordHash = process.env.REACT_APP_ADMIN_PASSWORD_HASH || "31323334353637383930";
  
  if (!emailHash || !passwordHash) {
    return { email: '', password: '' };
  }
  
  return {
    email: hexDecode(emailHash),
    password: hexDecode(passwordHash)
  };
};

// Get dev mode credentials (still client-side, but obfuscated)  
export const getDevCredentials = () => {
  const emailHash = process.env.REACT_APP_DEV_EMAIL_HASH || "6163617272656f6d40616d617a6f6e2e636f6d";
  const passwordHash = process.env.REACT_APP_DEV_PASSWORD_HASH || "31323334353637383930";
  
  if (!emailHash || !passwordHash) {
    return { email: '', password: '' };
  }
  
  return {
    email: hexDecode(emailHash),
    password: hexDecode(passwordHash)
  };
};

// Validate admin credentials
export const validateAdminCredentials = (email, password) => {
  const adminCreds = getAdminCredentials();
  return email === adminCreds.email && password === adminCreds.password;
};

// Validate dev credentials
export const validateDevCredentials = (email, password) => {
  const devCreds = getDevCredentials();
  return email === devCreds.email && password === devCreds.password;
};

